import * as yup from "yup";

export const CreateFarmerOrder = yup.object().shape({
  productId: yup.number(),
  orderTo: yup.number().required("Required"),
  accId: yup.number(),
  quantity: yup.number().required("Quantity is reqired"),
  totalAmount: yup.number(),
  shippingAddress: yup.number(),
});
